'use client';

import styles from './index.module.scss';
import AppStoreButtons from '@/app/_components/Shared/AppStoreButtons';

const appFeatures = [
  "View all your active requests in one dashboard",
  "Track visa and government processes step by step",
  "Receive real-time status updates",
  "Access documents anytime",
  "Communicate easily with the Ninjaz team",
];

export default function NinjazAppSection() {
  return (
    <section className={styles.container} id="ninjaz-app">
      <div className="container-wrapper">
        <div className={styles.content}>
          <div className={styles.textContent}>
            <div className={styles.badge}>Ninjaz App</div>
            <h2 className={styles.title}>
              Track your requests. Stay in control. Anytime, anywhere.
            </h2>
            <p className={styles.description}>
              The Ninjaz app gives you full visibility over your PRO services and visa processes in real time. No more chasing updates or guessing statuses — everything is tracked, organized, and accessible from your phone.
            </p>

            <div className={styles.features}>
              <h3 className={styles.featuresTitle}>What you can do with the Ninjaz app</h3>
              <ul className={styles.featuresList}>
                {appFeatures.map((feature, index) => (
                  <li key={index} className={styles.featureItem}>
                    <svg className={styles.checkIcon} fill="none" stroke="currentColor" viewBox="0 0 24 24" width="20" height="20">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>

            <div className={styles.downloadSection}>
              <h3 className={styles.downloadTitle}>Download the app</h3>
              <p className={styles.downloadSubtitle}>Available on iOS and Android.</p>
              <AppStoreButtons />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
